import moment from 'moment'
import React, { useState } from 'react'
import FontAwesome from 'react-fontawesome'
import Form from 'react-bootstrap/Form'
import I18n from 'resources/i18n/I18n'

const FIELDS = [
  { key: 'arretTravail', label: () => I18n.t('ArretTravail'), type: 'number' },
  { key: 'itt', label: () => I18n.t('ITT'), type: 'number' },
  { key: 'prejudice', label: () => I18n.t('Prejudice'), type: 'number' },
  { key: 'autrePrejudice', label: () => 'Autre préjudice', type: 'text', placeholder: 'Ex: déménagement, changement de poste...' },
]

const PrejudiceFields = ({ status, editStatus, readOnly, previousAutrePrejudices }) => {
  const [collapsed, setCollapsed] = useState(true)
  const autrePrejudices = previousAutrePrejudices || []

  return (
    <div className="prejudice-section">
      <div className="prejudice-header" onClick={() => setCollapsed(!collapsed)}>
        <span className="subtitle">Préjudice</span>
        <FontAwesome name={collapsed ? 'chevron-down' : 'chevron-up'} />
      </div>
      {!collapsed && (
        <div className="prejudice-body">
          {FIELDS.map(({ key, label, type, placeholder }) => (
            <div key={key}>
              <span className="subtitle-field">{label()}</span>
              <Form.Group>
                <Form.Control
                  type={type}
                  placeholder={placeholder}
                  defaultValue={status[key] || ''}
                  onChange={(e) => editStatus({ ...status, [key]: e.target.value })}
                  readOnly={readOnly}
                />
              </Form.Group>
            </div>
          ))}
          {autrePrejudices.length > 0 && (
            <div className="autre-prejudice-recap mt-2">
              <span className="subtitle-field">Autres préjudices précédents :</span>
              <ul className="autre-prejudice-list">
                {autrePrejudices.map((p, idx) => (
                  <li key={idx}>
                    {p.text}
                    <span className="action-traceability">
                      {' '}
                      — {p.idUser}
                      {p.date && `, ${moment(p.date).format('DD/MM/YYYY HH:mm')}`}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default PrejudiceFields
